<template>
    <icon-base v-bind="$props">
        <circle cx="12" cy="12" r="8" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="12" cy="12" r="0.5" fill="currentColor" />
    </icon-base>
</template>

<script setup>
import IconBase, { iconProps } from './IconBase.vue'

defineProps(iconProps)
</script>
